import { createFileRoute, notFound } from "@tanstack/react-router";

import { eventQueries } from "../features/events/api/queries";
import { EditEventDialog } from "../features/events/components/EditEventDialog";
import { organiserQueries } from "../features/organisers/api/queries";
import { tagQueries } from "../features/tags/api/queries";
import { venueQueries } from "../features/venues/api/queries";
import { areaQueries } from "../features/weather/api/queries";
import { AppHeader } from "../shared/ui/AppHeader";

export const Route = createFileRoute("/_authenticated/events/$eventId/edit")({
  loader: async ({ params, context: { queryClient } }) => {
    const [data] = await Promise.all([
      queryClient.ensureQueryData(eventQueries.detail(params.eventId)),
      // The tag, venue and organiser pickers need their options before first paint.
      queryClient.ensureQueryData(tagQueries.list()),
      queryClient.ensureQueryData(venueQueries.list()),
      queryClient.ensureQueryData(organiserQueries.list()),
      queryClient.ensureQueryData(areaQueries.list()),
    ]);
    if (!data.event) throw notFound();
  },
  component: EditEventPage,
});

/** Chrome behind the modal; the dialog itself owns the editing. */
function EditEventPage() {
  const { eventId } = Route.useParams();

  return (
    <>
      <AppHeader />
      <EditEventDialog eventId={eventId} />
    </>
  );
}
